import {useDispatch} from "react-redux";
import {deletePlayer} from "../../../redux/playersSlice";
import {IPlayer, PlayerState} from "../../types";
import {ReactComponent as Edit} from "../../../images/icons/edit.svg";
import {ReactComponent as Delete} from "../../../images/icons/trash.svg";
import {useTranslation} from "react-i18next";
import React from "react";
import "./Player.css";

interface Props{
    player: IPlayer;
    updatePlayer?: (player: IPlayer) => void;
    onPlayerSelectionChange?: (id: string, selected: boolean) => void;
    hideActions?: boolean;
}
const Player = ({ player, updatePlayer, onPlayerSelectionChange, hideActions}: Props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const onDeleteClick = () => {
        const confirmMessage = window.confirm(t('games.alerts.deleteConfirm') + ` ${player.name}?`);
        if (confirmMessage) {
            dispatch(deletePlayer(player.id));
        } else return;
    };

    const imgClickHandler = () => {
        if (player.state === PlayerState.DISABLED) return;
        if (onPlayerSelectionChange) {
            onPlayerSelectionChange(player.id, player.state !== PlayerState.SELECTED)
        } else return;
    };

    const handleUpdate = () => {
        if (updatePlayer) {
            updatePlayer(player);
        } else return;
    };

    const hoverable = !!onPlayerSelectionChange && player.state !== PlayerState.DISABLED && player.state !== PlayerState.SELECTED;
    const updatable = !!updatePlayer && player.state !== PlayerState.DISABLED;
    const containerClass = `player ${player.state} ${hoverable ? 'hoverable' : ''}  ${updatable ? 'updatable' : ''}`;
    
    const actions = !hideActions && <div className="actions">
        <button data-testid="btn-edit" type="button" onClick={handleUpdate}><Edit /></button>
        <button type="button" onClick={onDeleteClick}><Delete /></button>
    </div>;

    return (
        <div data-testid={`player-${player.id}`} className={containerClass}>
            <img src={player.avatarUrl} alt={player.name} onClick={imgClickHandler} onTouchStart={imgClickHandler}/>
            <p className="name">{player.name}</p>
            {actions}
        </div>
    )
};

export default Player;
